import { Skeleton, Stack } from "@mui/material";
import BoxLegend from "../../../../common/BoxLegend";
import { useEffect, useRef, useState } from "react";
import { filterTickets, getAssignationIndicators } from "../../../../../services/ticket.service";
import { TicketsFilterFormModel } from "../../../../../models/ticket.model";
import { TICKET_STATUS_OPEN } from "../../../../../assets/appConstants/constants";
import { useProject } from "../../../../../context/ProjectContext";
import { useTicketsFilterContext } from "../../../../../context/TicketsFilterContext";
import FilterChip from "../../../../common/ActionChip/FilterChip";
import './index.css'


interface AssignationIndicatorsBarProps {
  setTicketsList: (p: any) => void
  resetPrimaryFilter: () => void
  filteredAssignationCode?: any
  setFilteredAssignationCode: (p: any) => void
  setLoadingTickets: (p: any) => void
  resetAssignationFilters?: boolean
}

export default function AssignationIndicatorsBar({ setTicketsList, resetPrimaryFilter, filteredAssignationCode, setFilteredAssignationCode,
  setLoadingTickets, resetAssignationFilters }: AssignationIndicatorsBarProps) {

  const { selectedProject } = useProject()
  const { setDefaultTicketsFilter, checkAppliedFilters } = useTicketsFilterContext()
  const [loadingAssignationIndicators, setLoadingAssignationIndicators] = useState<boolean>(false)

  const [filterAssignationForm, setFilterAssignationForm] = useState<TicketsFilterFormModel>(
    {
      number: [],
      project_id: selectedProject
    }
  )

  let AssignationValues = useRef<[{ code: string, name: string, values: [] }] | []>([])
  const [reloadAssignationIndicators, setReloadAssignationIndicators] = useState<boolean>(false)
  const [assignationIndicators, setAssignationIndicators] = useState<any[]>([])

  const rootStyles = getComputedStyle(document.documentElement);
  const filterChipBgColor = rootStyles.getPropertyValue('--filter-chip-bkg-color').trim();
  const filterChipTextColor = rootStyles.getPropertyValue('--filter-chip-text-color').trim();

  const one_sec = 1000

  useEffect(() => {
    setFilteredAssignationCode('')
  }, [resetAssignationFilters])

  const setFilter = () => {
    if (filteredAssignationCode) {
      setLoadingTickets(true)
      Promise.all([filterTickets(selectedProject, filterAssignationForm)]).then(function (results) {
        setTicketsList(results[0])
        setLoadingTickets(false)
      }).catch((error) => {
        setLoadingTickets(false)
      });
    }
  }

  useEffect(setFilter, [filteredAssignationCode])

  const handleSubmit = (data: { code: string, name: string, values: [] }) => {
    if (!filteredAssignationCode) {
      setDefaultTicketsFilter()
      checkAppliedFilters({ number: '', status: TICKET_STATUS_OPEN, project_id: selectedProject })
      setFilterAssignationForm({ ...filterAssignationForm, number: data.values, project_id: selectedProject })
      setFilteredAssignationCode(data.code)
    } else {
      setFilteredAssignationCode('')
      resetPrimaryFilter()
    }
  }

  const loadAssignationIndicators = () => {
    setLoadingAssignationIndicators(true)
    Promise.all([getAssignationIndicators(selectedProject)])
      .then(function (results) {
        AssignationValues.current = results[0]
        setReloadAssignationIndicators(!reloadAssignationIndicators)
        setTimeout(() => { setLoadingAssignationIndicators(false) }, one_sec)
      }).catch((error) => {
        setTimeout(() => { setLoadingAssignationIndicators(false) }, one_sec)
      }
      )
  }

  useEffect(loadAssignationIndicators, [selectedProject])


  const makeBody = () => {
    let new_body: any = []
    for (let i = 0; i < AssignationValues.current.length; i++) {
      new_body.push(
        <FilterChip
          key={AssignationValues.current[i].code}
          label={AssignationValues.current[i].name}
          counter={AssignationValues.current[i].values.length}
          color={filterChipBgColor}
          textColor={filterChipTextColor}
          disabled={AssignationValues.current[i].code !== filteredAssignationCode && filteredAssignationCode !== ''}
          onClick={() => { handleSubmit(AssignationValues.current[i]) }}
        />
      )
    }
    setAssignationIndicators(new_body)
  }

  useEffect(makeBody, [reloadAssignationIndicators, filteredAssignationCode])

  return (
    (assignationIndicators.length > 0) ? (
      <div className="assignation-indicators-bar">
        <BoxLegend
          title="Asignación"
          content={loadingAssignationIndicators ? <>
            <Skeleton variant="text" width={375} height={11} />
            <Skeleton variant="text" width={375} height={11} />
          </>
            : <Stack useFlexGap flexWrap="wrap" direction="row" spacing={1}>{assignationIndicators}</Stack>}
        />
      </div>) : <div className="assignation-indicators-bar"></div>
  )
}